import { render, staticRenderFns } from "./m_changedata.vue?vue&type=template&id=1b04fa0e&scoped=true&"
import script from "./m_changedata.vue?vue&type=script&lang=js&"
export * from "./m_changedata.vue?vue&type=script&lang=js&"
import style0 from "./m_changedata.vue?vue&type=style&index=0&id=1b04fa0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04fa0e",
  null
  
)

export default component.exports